import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import {
  AuthRenderState,
  LoyaltyCurrency,
  NavLink,
  PointsSummary,
} from '@rd/types';
import { NavLinksService } from '../../services/dropdown-link-items/nav-links.service';
import { UrlUtilsService } from '../../services/url-utils/url-utils.service';

@Component({
  selector: 'rd-core-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SideNavComponent {
  @HostBinding('class.rd-core-side-nav') componentClass = true;
  @Input() authRenderState: AuthRenderState;
  @Input() pointsSummary: PointsSummary;
  @Input() showSideNav: boolean;
  @Input() loyaltyCurrencySelected?: LoyaltyCurrency;
  @Output() itemClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() logout: EventEmitter<void> = new EventEmitter<void>();

  navLinks: NavLink[];
  logoutNavLink: NavLink;

  constructor(
    protected navLinksService: NavLinksService,
    protected urlUtilsService: UrlUtilsService,
  ) {
    this.navLinks = this.navLinksService.allNavLinks;
    this.logoutNavLink = this.navLinksService.logoutNavLink;
  }

  imageUrl(iconUrl: string): string {
    return this.urlUtilsService.imageUrl(iconUrl);
  }

  itemClickEmit(): void {
    this.itemClick.emit();
  }

  logoutEmit(): void {
    this.logout.emit();
  }

  pointsSummaryLoading(): boolean {
    return !this.pointsSummary;
  }

  pointsCurrencyShortName(): string {
    return this.loyaltyCurrencySelected?.shortName ?? '';
  }
}
